<template>
    <div class="convention-obligations" v-if="user && (canViewAllConventions || isMyConvention)">
        <convention-sections-filters
            :cspFilters="cspFilters"
            :isAllCsp="convention.cspConfig.allIncluded"
            :convention="convention"
            @change="onCspFiltersChange"
        />
        <main-container>
            <v-row class="convention-sections">
                <sep name="XL" />
                <convention-sections
                    :cspFilters="cspFilters"
                    :convention="conventionSectionsFiltered"
                    ref="sections"
                />
            </v-row>
        </main-container>
    </div>
</template>

<script>
import ConventionSectionsFilters from "./filters/ConventionSectionsFilters.vue";
import ConventionSections from "./sections/ConventionSections.vue";
import scrollManager from "src/components/convention/managers/scrollManager";
import { EventBus } from "src/bus/eventBus";
import userMixin from "src/mixins/user";
import { head, get } from "lodash";

export default {
    mixins: [userMixin],
    components: {
        ConventionSections,
        ConventionSectionsFilters,
    },
    props: ["convention", "user"],
    data() {
        return {
            cspFilters: get(this.convention, "cspConfig.availableCodes", []),
            currentSelectedIds: null,
        };
    },
    mounted() {
        EventBus.$on("convention-sections:scrolled", m => {
            if (m == "table") this.currentSelectedIds = null;
        });
        EventBus.$on("convention-section-title:scrolled", i => (this.currentSelectedIds = i));
        this.$nextTick(() => {
            window.print();
        });
        if (this.$route.query.csp) {
            this.onCspFiltersChange(this.$route.query.csp.split(","));
        }
    },
    methods: {
        onCspFiltersChange(cspFilters) {
            if (cspFilters.length > 0) {
                this.cspFilters = cspFilters;
                if (this.currentSelectedIds) {
                    const id = head(this.currentSelectedIds);
                    // Wait until content is updated on the page and then scroll
                    setTimeout(() => {
                        scrollManager.scrollToId(id);
                    }, 100);
                }
            }
        },
    },
    computed: {
        conventionSectionsFiltered() {
            const { sectionKey } = this.$route.params;
            return {
                ...this.convention,
                sections: this.convention.sections.filter(section => section.key === sectionKey),
            };
        },
    },
};
</script>

<style scoped lang="sass">
.convention-obligations
    background: $color-background
    padding: $grid-gutter/2 0

@media print
    .convention-obligations
        padding: 0
        background-color: transparent

    .convention-sections
        position: relative
        display: block
        margin: 3mm 0 0

    .col
        flex: 0 0 auto
        max-width: 100%
        width: auto
        padding: 0
</style>
